export const heroInfo = {
  eyebrow: {
    day: '18',
    month: 'июня',
    year: '2026',
    place: 'Новосибирск, Mirotel'
  },
  titlePrefix: 'Форум:',
  titleAccent: 'ИИ',
  title: 'для бизнеса',
  subtitle: ['Как бизнесу расти', 'и зарабатывать', 'с помощью ИИ'],
  primaryAction: {
    label: 'Купить билет',
    href: '/tariff'
  },
  secondaryAction: { label: 'Смотреть программу', href: '#program' }
};

export const heroBenefits = [
  { label: ['Рост', 'выручки'], iconSrc: '/icons/hero-icon-growth.svg' },
  { label: ['Снижение', 'издержек'], iconSrc: '/icons/hero-icon-costs.svg' },
  { label: ['Ускорение', 'процессов'], iconSrc: '/icons/hero-icon-speed.svg' },
  { label: ['Меньше', 'рутины'], iconSrc: '/icons/hero-icon-routine.svg' },
  { label: ['Улучшение', 'сервиса'], iconSrc: '/icons/hero-icon-service.svg' }
];

export const heroBackgrounds = {
  desktop: '/images/hero-bg-desktop.png',
  tablet: '/images/hero-bg-tablet.png',
  mobile: '/images/hero-bg-mobile.png'
};
